import { Drawer } from '@/components';
import {
  useCreatePaymentEdge,
  usePaymentEdges,
  useUpdatePaymentEdge,
} from '@/features/project/projects/detail/payment/_hooks/payment-edge';
import { useId } from '@/hooks';
import { t } from '@/i18n';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import invariant from 'tiny-invariant';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { PaymentEdgeForm } from './PaymentEdgeForm';

export const PaymentEdgeDrawer: FC = () => {
  const { id: projectId } = useId();
  const { openMessage } = useMessage();
  const { drawerState, setDrawerState } = useProjectDetailDrawerState();

  const { mutateAsync: createPaymentEdgeAsync } = useCreatePaymentEdge();
  const { mutateAsync: updatePaymentEdgeAsync } = useUpdatePaymentEdge();

  const paymentEdges = usePaymentEdges(projectId);

  const handleCloseDrawer = async () => {
    setDrawerState({ open: false });
  };

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'payment-edge'}
      onClose={handleCloseDrawer}
      destroyOnClose
    >
      <PaymentEdgeForm
        {...(drawerState.open &&
        drawerState.type === 'payment-edge' &&
        drawerState.isEditing
          ? {
              initialValues: {
                ...(() => {
                  const current = paymentEdges.data?.find(
                    (paymentEdge) =>
                      paymentEdge.id === drawerState.paymentEdgeId,
                  );
                  return current ?? {};
                })(),
              },
              isEditing: true,
            }
          : {})}
        onSubmit={async (values) => {
          invariant(
            drawerState.open && drawerState.type === 'payment-edge',
            t('unreachable-code'),
          );

          drawerState.isEditing
            ? await updatePaymentEdgeAsync({
                id: drawerState.paymentEdgeId,
                projectId,
                ...values,
              })
            : await createPaymentEdgeAsync({
                projectId,
                ...values,
              });

          await Promise.all([
            openMessage(
              'success',
              drawerState.isEditing
                ? t('message-update-completed')
                : t('add-completed'),
            ),
            handleCloseDrawer(),
          ]);
        }}
      />
    </Drawer>
  );
};
